<template>
  <div class="kt-portlet kt-portlet--height-fluid">
    <div
      class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm"
    >
      <div class="kt-portlet__head-label">
        <span class="kt-portlet__head-icon">
          <i class="fa fa-envelope-o"></i>
        </span>
        <h3 class="kt-portlet__head-title">Email Logs</h3>
      </div>
    </div>
    <div class="kt-portlet__body">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        @keyup="renderSearch"
      ></v-text-field>
      <v-data-table
        loading-text="Loading... Please wait"
        :headers="headers"
        :items="emails"
        :options.sync="options"
        :loading="isFetching"
        :server-items-length="pagination.total"
        :items-per-page="pagination.per_page"
        :footer-props="{ disablePagination: paginationDisable }"
        class="elevation-1"
      >
        <template v-slot:item.created_at="{ item }">
          {{ formatDate(item.created_at) }}
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'EmailLogsTable',
  data() {
    return {
      search: '',
      paginationDisable: false,
      options: {},
      pagination: {
        total: 1,
        per_page: 10,
        current_page: 1,
        search: '',
        sortBy: '',
        sortDesc: false,
      },
      emails: [],
      isFetching: false,
      timeout: null,
      headers: [
        {
          text: 'Status',
          sortable: true,
          align: 'left',
          value: 'status',
          width: 100,
        },
        {
          text: 'Email',
          align: 'center',
          value: 'email',
          sortable: true,
          width: 200,
        },
        {
          text: 'Subject',
          sortable: true,
          align: 'center',
          value: 'subject',
          width: 200,
        },
        {
          text: 'Message',
          align: 'center',
          sortable: true,
          value: 'message',
          width: 300,
        },
        {
          text: 'Location',
          align: 'center',
          value: 'location',
          width: 200,
        },
        {
          text: 'UUID',
          align: 'center',
          value: 'uuid',
          width: 300,
        },
        {
          text: 'Created At',
          align: 'center',
          value: 'created_at',
          width: 200,
        },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.changeTable();
      },
      deep: true,
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    renderSearch() {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.options.page = 1;
        this.changeTable();
      }, 1000);
    },
    formatDate(date) {
      if (!date) return 'N/A';
      return dayjs(date).format('MMM D, YYYY, h:mm a');
    },
    initialize() {
      this.isFetching = true;
      this.paginationDisable = true;
      this.emails = [];
      this.$http
        .get('/email-logs', {
          params: {
            per_page: this.pagination.per_page,
            current_page: this.pagination.current_page,
            sortBy: this.pagination.sortBy,
            sortDesc: this.pagination.sortDesc,
            search: this.search,
          },
        })
        .then(({ data }) => {
          this.emails = data.data;
          this.isFetching = false;
          this.pagination.total = data.total;
          this.pagination.current_page = data.page;
          this.pagination.per_page = data.perPage;
          this.paginationDisable = false;
        });
    },
    changeTable() {
      this.pagination.current_page = this.options.page;

      this.pagination.sortBy =
        this.options.sortBy !== undefined ? this.options.sortBy[0] : '';
      this.pagination.sortDesc =
        this.options.sortDesc !== undefined ? this.options.sortDesc[0] : '';

      this.initialize();
    },
  },
};
</script>
